import { render, staticRenderFns } from "./zhuiSu.vue?vue&type=template&id=e67f09b2"
import script from "./zhuiSu.vue?vue&type=script&lang=js"
export * from "./zhuiSu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports